import { render, staticRenderFns } from "./TheLogoPlaceholderIcon.vue?vue&type=template&id=213f439b"
import script from "./TheLogoPlaceholderIcon.vue?vue&type=script&lang=js"
export * from "./TheLogoPlaceholderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports